module.exports = __webpack_public_path__ + "static/media/icon-event-location.2c953e99.svg";